{
    "charts": {
        "terminals": {
            "status": {
                "title": "Terminaux",
                "tooltip": "Répartition des TPE (hors abonnement résiliés)",
                "description": "Par statut",
                "count": "Nombre :"
            },
            "networks": {
                "title": "Réseaux",
                "tooltip": "Répartition par mode de communication (hors abonnement résiliés)",
                "description": "Par réseau",
                "count": "Nombre :",
                "network_interface_type": {
                    "UNKNOWN": "Inconnu",
                    "GPRS": "Gprs",
                    "IP_WIFI": "IP / Wifi",
                    "GPRS_IP_WIFI": "Gprs / IP / Wifi"
                }
            },
            "manufacturers": {
                "title": "Constructeur",
                "tooltip": "Répartition par constructeur (hors abonnement résiliés)",
                "description": "Par constructeur",
                "count": "Nombre :"
            }
        },
        "sim_offers": {
            "title": "Forfaits SIM",
            "tooltip": "Répartition des forfaits par fournisseur",
            "description": "Par fournisseur",
            "count": "Nombre :"
        },
        "contracts": {
            "applications": {
                "title": "Contrats par application",
                "tooltip": "Répartition des contrats actifs (TLC < 30 jours) par type d’application",
                "description": "Par application",
                "count": "Nombre :"
            },
            "cb_versions": {
                "title": "Version applicative",
                "tooltip": "Répartition des contrats actifs (TLC < 30 jours) par version CB",
                "description": "Par version CB",
                "count": "Nombre :"
            }
        }
    },
    "global_stats": {
        "pos_terminals": {
            "title": "Parc TPE",
            "tooltip": "Hors abonnements résiliés"
        },
        "remote_collection_24h_count": {
            "title": "Télécollectes",
            "tooltip": "Nombre de TLC dans les dernières 24 heures"
        },
        "subscriptions": {
            "title": "Activation",
            "tooltip": "Abonnements activés sur les dernières 24h"
        },
        "sim_cards": {
            "active": {
                "title": "SIM actives",
                "tooltip": "Nombre de SIM en statut actif"
            },
            "stock": {
                "title": "SIM en stock",
                "tooltip": "Nombre de SIM en statut inactif",
                "WIRELESS_LOGIC": "{{number}} SIM service",
                "BOUYGUES_TELECOM": "{{number}} BT"
            }
        }
    },
    "redirection": {
        "pos_terminals": "Consulter les terminaux",
        "sim_cards": "Consulter les cartes SIM",
        "contracts": "Consulter les contrats"
    }
}